import React from 'react';
import { Quiz } from './Quiz';
import { PeerPoll } from './PeerPoll';
import { EvidenceSection } from './EvidenceSection';
import { DeepDiveCard } from './DeepDiveCard';
import { CTAButton } from './CTAButton';
import { Footer } from './Footer';
interface QuizOption {
  text: string;
  isCorrect: boolean;
  feedback?: string;
}
interface TopicData {
  heroImage: string;
  heroAlt: string;
  quiz: {
    question: string;
    options: QuizOption[];
  };
  poll: {
    percentage: number;
  };
  evidence: {
    content: string;
  };
  deepDive: {
    title: string;
    subtitle: string;
    icon?: React.ReactNode;
  };
  cta: {
    text: string;
    onClick?: () => void;
  };
}
interface TopicScreenProps {
  data: TopicData;
}
export function TopicScreen({
  data
}: TopicScreenProps) {
  return <div className="min-h-screen bg-white overflow-y-auto pb-20" data-id="element-135">
      {/* Layer 1: Emotional Image */}
      <div className="w-full aspect-[16/9] bg-gray-200 overflow-hidden" data-id="element-136">
        <img src={data.heroImage} alt={data.heroAlt} className="w-full h-full object-cover" data-id="element-137" />
      </div>

      {/* Layer 2: Interactive Quiz */}
      <Quiz question={data.quiz.question} options={data.quiz.options} data-id="element-138" />

      {/* Layer 3: Peer Poll */}
      <PeerPoll percentage={data.poll.percentage} data-id="element-139" />

      {/* Layer 4: Evidence Section */}
      <EvidenceSection content={data.evidence.content} data-id="element-140" />

      {/* Layer 5: Deep Dive Card */}
      <DeepDiveCard title={data.deepDive.title} subtitle={data.deepDive.subtitle} icon={data.deepDive.icon} data-id="element-141" />

      {/* Layer 6: Next Topic CTA */}
      <CTAButton onClick={data.cta.onClick} data-id="element-142">{data.cta.text}</CTAButton>

      {/* Footer */}
      <Footer data-id="element-143" />
    </div>;
}